import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ConfigService } from "../../config.service";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { environment } from '../../../../../environments/environment';
import { ReportPayload } from "../../../models/report/report.model";

@Injectable({
  providedIn: 'root',
})

export class ApiReportService {
  private tokenUrl = `${environment.apiPrivateUrl}`;

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private apiMethods: ApiMethodService,
  ) { }

  // ส่งข้อมูลรายงานปัญหาแอปพลิเคชัน
  sendReport(uid: string, token: string, payload: ReportPayload) {
    return this.apiMethods.request<any>(
      '/Cityparking/sendReport',
      'POST',
      this.tokenUrl,
      {
        body: payload,
        params: { uid: uid },
        isConsoleLog: true,
        headerOnly: false,
        labelLog: 'SendReport',
      },
    );
  }

}